import React from "react";
import { Box, Typography } from "@mui/material";
import "./TermsAndCondition.scss";

export default function TermsAndCondition() {
  // Platform values
  const platformName = "Siki";
  const platformNameFull = "Siki.io";
  const platformDomain = "siki.io";
  const platformUrl = "https://www.siki.io/";
  const companyName = "SIKI Holding Corp";
  const companyAddress = "8275 S Eastern Ave, Suite 200, Las Vegas, NV 89123";

  return (
    <Box className="terms-container">
      <Box className="terms-content">
        <Typography className="fs-24 text-center my">
          Terms of Services
        </Typography>
      <Typography className="fs-14 text-center my" style={{ fontStyle: 'italic' }}>
        Last Updated: September 21, 2026
      </Typography>
      <Typography className="fs-20  my">Terms and Conditions</Typography>

      {/* 1 */}
      <div className="my-10">
        <Typography className="fs-16">
          1. Acceptance Of Terms; Modification Of Terms
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          {companyName} ("<b>{platformName}</b>") owns, controls and operates the
          platform known as "{platformNameFull}", a web-based, content streaming and
          sharing service available at our website, {platformUrl}
          (including all subdomains and related websites owned and operated by
          {" "}{platformName}, collectively the "Site"), and through {platformName}'s desktop and/or
          mobile applications (including any backend developer applications,
          collectively, the "App" and together with the Site, the "{platformName}{" "}
          Service" or the "Platform").
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          These Terms of Use and all other terms and conditions, policies,
          guidelines, and documents incorporated by reference herein, including,
          without limitation, our Privacy Policy available at{" "}
          <a href="/PrivacyPolicy">
            https://{platformDomain}/PrivacyPolicy
          </a>{" "}
          ("Privacy Policy") (collectively, the "Terms of Use"), constitute a
          legally binding agreement between {platformName} and each registered or
          unregistered end user and/or participant of the Platform (each, a
          "User", "you" or "your", and as described herein).{" "}
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          By accessing and using the Platform and/or creating any type of User
          profile account on the Platform (an “Account”), in any manner,
          including, but not limited to, visiting or browsing the Platform,
          publishing or listening to Content (as defined herein) on or through
          the Platform, you are deemed to have read,
          accepted, executed, and be bound by these Terms of Use. YOU MUST BE AT
          LEAST THIRTEEN (13) YEARS TO ACCESS AND USE THE PLATFORM; PROVIDED, IF
          YOU ARE BETWEEN THE AGES OF THIRTEEN (13) AND EIGHTEEN (18) YEARS OLD
          (OR ANY GREATER AGE REQUIRED TO BE DEEMED TO HAVE REACHED THE AGE OF
          MAJORITY UNDER THE APPLICABLE LAW OF THE STATE OR JURISDICTION OF YOUR
          PRIMARY RESIDENCE) YOU MAY ONLY ACCESS AND USE THE PLATFORM WITH THE
          PRIOR PERMISSION OF YOUR PARENT OR LEGAL GUARDIAN, AND YOU REPRESENT
          AND WARRANT TO SIKI THAT YOU HAVE SUCH PERMISSION AND THAT YOUR PARENT
          OR LEGAL GUARDIAN HAS REVIEWED AND DISCUSSED THESE TERMS OF USE WITH
          YOU. SINCE CERTAIN CONTENT (i.e., SOUND RECORDINGS THAT MAY CONTAIN
          EXPLICIT LYRICS, ETC.) MADE AVAILABLE ON THE PLATFORM MAY NOT BE
          SUITABLE FOR MINORS, WE RECOMMEND THAT PARENTS OR LEGAL GUARDIANS WHO
          PERMIT THEIR CHILD TO ACCESS AND USE THE PLATFORM TO SUPERVISE SUCH
          CHILD’S ACTIVITY, INCLUDING, WITHOUT LIMITATION, ANY ENGAGEMENT WITH
          ANY OTHER USER THEREON.
        </Typography>
        <Typography className="fs-14 text-justify my-10 ml-40">
          (1) Users who publish or otherwise make Content available on or
          through the Platform that can be accessed, listened to or otherwise
          interacted with by Listeners (“Creators”);
        </Typography>
        <Typography className="fs-14 text-justify my-10 ml-40">
          (2) Users who access, listen to and/or otherwise interact with Content
          published or otherwise made available on or through the Platform by
          Creators (“Listeners”);
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          {platformName} may change or amend these Terms of Use at any time at its sole
          and absolute discretion. {platformName}encourages you to review these Terms of
          Use carefully and to check these Terms of Use periodically for any
          updates or changes. If {platformName}makes a material change or amendment to
          these Terms of Use, {platformName}will provide a notification of such changes
          or amendments on the Platform, which changes, or amendments will be
          effective automatically upon the posting of such notification. You
          agree that all agreements, notices, disclosures and other
          communications {platformName}provides to you electronically satisfy any legal
          requirement that such communications be in writing. Notwithstanding
          anything to the contrary contained herein, no revisions to the Terms
          of Use will apply to any dispute between you and {platformName}that arose prior
          to the effective date of such revision. 
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          {platformName} may, from time to time, release new versions of the Platform, or
          release or introduce new tools, products, services, functionalities,
          and/or features for the Platform, which will be subject to these Terms
          of Use, and any additional terms and conditions as may apply to such
          additional versions, tools, products, services, functionalities, or
          features. 
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          IF ANY PROVISION OF THESE TERMS OF USE OR ANY FUTURE CHANGES ARE
          UNACCEPTABLE TO YOU, DO NOT USE OR CONTINUE TO USE THE PLATFORM AND DO
          NOT CREATE OR CONTINUE TO MAINTAIN AN ACCOUNT. YOUR CONTINUED USE OF
          THE PLATFORM FOLLOWING THE POSTING OF ANY NOTICE OF ANY CHANGE TO
          THESE TERMS OF USE SHALL AUTOMATICALLY CONSTITUTE YOUR ACCEPTANCE AND
          AGREEMENT TO SUCH CHANGE.
        </Typography>
      </div>
      {/* 2 */}
      <div className="my-10">
        <Typography className="fs-16">2. Platform License</Typography>
        <Typography className="fs-14 text-justify my-10">
          {platformName}hereby grants you a limited, non-exclusive, revocable (solely
          with respect to the {platformName}Service), royalty-free, non-transferable,
          non-assignable, non-sublicensable, right and license to access and
          make personal use of the Platform, the “Platform Elements” (as defined
          below), and the Content, solely as permitted by the tools, products,
          services, functionalities and/or features made available to Users of
          the Platform, subject in all respects to these Terms of Use, and not
          for redistribution of any kind (the “Platform License”). Except as
          otherwise expressly set forth herein, this Platform License does not
          include any resale or, except as expressly set forth herein,
          commercial use of (i) the Platform, (ii) any “Registration Data” (as
          defined below), (iii) any content, materials, information, text, data,
          copyrights, “Trademarks” (as defined below), logos, designs, insignia,
          images, photos, musical compositions, sound recordings, screenshots,
          videos, chats, posts, graphics, identifying marks, Platform pages,
          software, code, and other original works of authorship and/or
          intellectual property uploaded to, or incorporated into, the Platform
          by or on behalf of {platformName}(collectively, “Platform Elements”), which
          Platform Elements are and shall remain the sole and exclusive property
          of {platformName}(or the applicable third-party licensor thereof), or (iv) any
          Content published or otherwise made available on or through the
          Platform by any Creator, which Content is and shall remain the sole
          and exclusive property of the applicable Creator (or the applicable
          third-party licensor thereof), subject to the Content License (defined
          herein) in and to such Content granted pursuant to these Terms of Use.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          As between any User and Siki, {platformName}retains all right, title and
          interest in and to the Platform 
          throughout the world, in perpetuity, including, without limitation,
          (i) all text, graphics, typefaces, formatting, graphs, designs,
          editorial content, HTML, look and feel, software, and data, (ii) all
          business processes, procedures, methods, and techniques used in the
          Platform, all other materials and content uploaded or incorporated
          into the Platform, including, without limitation, all Platform
          Elements (but excluding Content, which as between {platformName}and the
          applicable User is owned by the applicable User subject to the Content
          License granted to {platformName}pursuant to these Terms of Use), (iii) all
          associated trade secret rights and other intellectual property and
          proprietary rights recognized anywhere in the world, and (v) the
          coordination, selection, arrangement and enhancement of the foregoing
          as a Collective Work under the United States Copyright Act, as amended
          (collectively, “Platform IP”), and nothing contained herein shall be
          construed as creating or granting to any User any right, title or
          interest in and to such Platform IP other than the express license
          granted therein pursuant to these Terms of Use. Platform IP is
          protected in all forms, media and technologies now known or
          hereinafter developed as well as by the domestic and international
          laws of copyright, trademarks, patents, and other proprietary rights
          and laws.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          {platformName}'s trademarks, service marks, and logos (collectively, the “Siki
          Trademarks”) used and displayed on the Platform are {platformName}'s registered
          and unregistered trademarks or service marks. Other product and
          service names located on the Platform may be trademarks or service
          marks owned by third parties (the “Third-Party Trademarks,” and,
          collectively with {platformName}Trademarks, the “Trademarks”). Except as
          otherwise permitted by law, you may not use the Trademarks to
          disparage {platformName}or the applicable third-party owner thereof, {platformName}'s or
          the applicable third-party’s products or services (including, without
          limitation, the Platform), or in any manner (using commercially
          reasonable judgment) that may damage any goodwill in the Trademarks.
          You may not use any Trademarks as part of a link to or from the
          Platform without {platformName}'s prior express written consent. All goodwill
          generated from the use of any Trademark will inure solely to the
          benefit of {platformName}or the applicable third-party owner thereof. Violation
          of this Platform License may result in infringement of intellectual
          property and contractual rights of Siki, other Users of the Platform,
          or other third parties, which is prohibited by law and could result in
          substantial civil and criminal penalties.
        </Typography>
      </div>
      {/* 3 */}
      <div className="my-10">
        <Typography className="fs-16">3. Accounts And Registration</Typography>
        <Typography className="fs-14 text-justify my-10">
          While you may browse the public-facing portions of the Platform
          without registering with us, in order to enjoy the full benefits of
          the Platform, or become a Creator, you must first register for and
          create an Account. You agree to create only one (1) unique Account and
          that you shall be the sole authorized user of your Account. As part of
          the registration process, Users will be asked to submit certain
          information such as their name, email address, profile name and
          photo/image, and to create an Account login password (collectively,
          “Registration Data”). Registration Data also includes your location by
          city and state, which you have the option to remove from your Account
          profile at any time. You may also link your Account to your Twitter or
          Instagram account, and in the future other social media accounts,
          through your Account settings options by providing your credentials,
          as applicable, and all data transfers in connection therewith shall be
          governed by our Privacy Policy. You agree and represent that all
          Registration Data you provide to {platformName}will be and remain at all times
          true, accurate, current and complete. {platformName} may from time to time
          modify or add to the Registration Data information fields required to
          create an Account, and you agree to promptly complete any such
          additional or modified information fields when and as requested by
          Siki. In some cases, in order to utilize certain features and
          functionalities of the Platform you will also need to update your
          Account and/or operating system settings to allow {platformName}to access your
          address book/contacts and camera/microphone functions, provided this
          will be voluntary and subject to you opting in to allow {platformName}access to
          such functions on your device. You must make sure that your Account
          profile name complies with these Terms of Use. Your registration with
          {platformName} is subject to our confirmation and will become valid when Siki
          either confirms your registration or activate your Account. {platformName}will
          have the right to use your Registration Data in connection with
          servicing and operating the Platform and in other manners as set forth
          in more detail in our Privacy Policy. You agree (i) to restrict access
          by any other person or entity to your password or other login
          information, (ii) to not knowingly use the name or email of any other
          person without authorization, (iii) to not use an email or profile
          name that is profane, offensive or otherwise inappropriate, (iv) to
          not allow any third-party to use your login information, Registration
          Data or Account, and (v) to not re-create any new or additional
          Account in the event your original Account is suspended or terminated
          in accordance with the terms hereof. You agree that you will be liable
          for all activities that occur under your Account, even if such
          activities were not committed by you. {platformName} is not responsible for any
          loss or damage as a result of someone else using your Account,
          Registration Data or password with or without your knowledge. You
          agree to notify {platformName} of any breach of security by promptly sending
          {platformName} an e-mail to contact@siki.io.
        </Typography>
      </div>
      {/* 3 */}
      <div className="my-10">
        <Typography className="fs-16">4. Listeners</Typography>
        <Typography className="fs-14 text-justify my-10">
          If you are accessing and using the Platform in your capacity as a
          Listener, you hereby acknowledge and agree that you may only make
          personal and non-commercial use of the Content published to the
          Platform by Creators, and you may not sell, license, rent, or
          otherwise exploit any such Content for commercial purposes or in any
          way that violates these Terms of Use or the rights of any third-party.
          Each Listener further acknowledges and agrees that a Creator may
          restrict or limit the specific manner in which such Listener can
          access, listen to, or otherwise interact with Content that such
          Creator has published or otherwise made available on or through the
          Platform (e.g., by permitting a Listener to stream certain Content but
          not download or share such Content off-Platform), or impose a fee for
          such Listener to access, listen to, or otherwise interact with such
          Content. Each Listener hereby agrees to comply with any imposed
          payment requirements and/or to use Content solely in accordance with
          the specific permissions granted and restrictions imposed by the
          applicable Creator thereof. Any use of Content outside of those
          permissions and/or restrictions set by the applicable Creator therefor
          requires the separate and express written permission of such Creator
          in each instance.
        </Typography>
      </div>
      {/* 5 */}
      <div className="my-10">
        <Typography className="fs-16">
          5. Creators Content Definition
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          As used in these Terms of Use, “Content” shall mean all sound
          recordings, musical compositions, metadata, information, text,
          artwork, copyrights, trademarks, logos, designs, insignia, data,
          information, and other content, materials, original works of
          authorship, and/or intellectual property that is published or
          otherwise made available on or through the Platform by a Creator for a
          Listener to access, listen to or otherwise interact with via the
          Platform.
        </Typography>

        <Typography className="fs-14 text-justify my-10">
          <b className="fs-16">Creator Content License</b> If you are accessing
          and using the Platform in your capacity as a Creator, you hereby
          represent and warrant to {platformName}that: (i) all Content that you publish
          or otherwise make available on or through the Platform is your
          original work of authorship for which you are the sole and exclusive
          owner, or that you have obtained all licenses, consents, releases, and
          other permissions from the applicable third-party owner(s) thereof as
          may be necessary to grant {platformName}the Content License in and to such
          Content hereunder, and (ii) the use of such Content by {platformName}and/or any
          other User or sublicensee of {platformName}does not, and will not, violate any
          applicable laws or the rights of any third-party, including, without
          limitation, any right of publicity, right of privacy, copyright,
          patent, trademark, or other intellectual property right or proprietary
          right. Each Creator acknowledges and agrees that its Content will be
          made publicly available to other Users on the Platform via the
          distribution functionalities described in, and in accordance with,
          these Term of Use. Each Creator further acknowledges and agrees that
          its Account profile name or login identifier will be linked to, or
          appear alongside, all such publicly available Content.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          In the future, {platformName} may implement functionality that permits you, as a
          Creator to impose a payment on Listeners in order to (i) enable
          Listeners to access, listen to or otherwise interact with Content that
          such Creator publishes or otherwise makes available on or through the
          Platform or (ii) make specific uses of such Content via the
          functionalities available on the Platform, may do so via their Account
          settings at the time such Content is published to the Platform or any
          time thereafter.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          Each Creator retains all right, title and interest in and to any
          Content (including all copyrights and other intellectual property
          rights related thereto or contained therein) that it publishes or
          otherwise makes available on or through the Platform; provided, that
          each such Creator hereby grants to {platformName}and its affiliates,
          successors, licensees, and assigns,
          a non-exclusive, worldwide, perpetual, irrevocable, royalty-free,
          fully paid (subject to any fee imposed on Listeners, as applicable),
          transferrable, assignable, sublicensable (through multiple tiers)
          right and license to use, copy, reproduce, display, distribute,
          publish, modify, adapt, make derivative works of, make collective
          works with, translate, and otherwise exploit (i) such Content
          (including all copyrights and other intellectual property rights
          related thereto or contained therein) and (ii) such Creator’s name,
          image, voice, likeness, profile information and biographical material
          (as applicable), and any other right of publicity/privacy held by such
          Creator in connection with such Content, in any and all media now
          known or hereafter discovered, in connection with the Platform
          (including, without limitation, the operation thereof and the
          provision of any tools, products, services, functionalities and/or
          features now or in the future offered in connection therewith), the
          advertising, marketing, promotion, publicity, and merchandizing of the
          Platform and any products and services related thereto, and to
          identify such Creator as the source of the applicable Content
          (collectively, the “Content License”).
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          For the avoidance of doubt, the Content License granted to Siki
          hereunder covers our ability to sublicense to, and permit, other Users
          of the Platform to, use each Creator’s Content in connection with all
          tools, products, services, functionalities and/or features made
          available in connection with the Platform from time to time, subject
          to these Terms of Use, and each Creator specifically acknowledges and
          agrees that certain rights being granted pursuant to the Content
          License will be sublicensed and passed through to other Users. Moreover, the Content License granted hereunder includes
          the right for {platformName} and other Users to reproduce, transmit and otherwise distribute sound
          recordings (and make mechanical reproductions of the musical works
          embodied in such sound recordings) via the Platform, and to publicly
          perform and communicate to the public sound recordings (and the
          musical works embodied therein) via the Platform, all on a
          royalty-free basis; which means that you are granting {platformName} and the other Users of the
          Platform (as applicable) the right to use your Content without the
          obligation to pay royalties to any third-party, including, but not
          limited to, a sound recording copyright owner (e.g., a record label),
          a musical work copyright owner (e.g., a music publisher), a performing
          rights organization (e.g., ASCAP, BMI, SESAC, etc.) (a “PRO”), a sound
          recording PRO (e.g., SoundExchange), any unions or guilds, and
          engineers, producers or other royalty participants involved in the
          creation of Content. If any Creator is a composer or author of a
          musical work and is affiliated with a PRO, then such Creator must
          notify your PRO of the royalty-free license it grants through these
          Terms of Use to us. Such Creator is solely responsible for ensuring
          its compliance with the relevant PRO’s reporting obligations. If such
          Creator has assigned its rights to a music publisher, then it must
          obtain the consent of such music publisher to grant the royalty-free
          license(s) set forth in these Terms of Use or have such music
          publisher enter into these Terms of Use with us. Creators should not
          presume that since it authored a musical composition that it has all
          the rights necessary to grant {platformName}the licenses in these Terms of Use.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          Each Creator acknowledges and agrees that certain functionalities and
          service offerings within the Platform enable Listeners to post
          hyperlinks to certain Content onto third party websites/applications,
          social media channels, and messaging platforms and that the Content
          License granted to {platformName}hereunder is provided on a
          through-to-the-audience basis, meaning the owners or operators of such
          third party websites/applications, social media channels, and
          messaging platforms will not have any separate liability to any
          Creator or any other third-party as a result of any such Content
          hyperlinks being uploaded to its service/platform.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          By uploading any Content to the Platform, each Creator waives any
          rights to prior inspection or approval of any marketing or promotional
          materials for the Platform that relate to such Content. Each Creator
          also waives any and all rights of privacy, publicity, or any other
          rights of a similar nature in connection with its Content, or any
          portion thereof, in connection with the use thereof as contemplated
          herein. To the extent any moral rights are not transferable or
          assignable, each Creator hereby waives and agrees never to assert any
          and all moral rights, or to support, maintain or permit any action
          based on any moral rights that it may have in or with respect to the
          use of any Content published or otherwise made available on or through
          the Platform in accordance with these Terms of Use.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          Each Creator acknowledges and agrees that {platformName} may establish general practices and limits concerning use of the Platform, including without limitation the maximum number of days that Content posted to the Platform will be retained by, or made available through, the Platform, and the maximum storage space allotted to a Creator, and that {platformName} has no responsibility or liability for the blocking or deleting of any Content or failure to store any Content maintained or transmitted by the Platform, except as required by law. Each Creator further
          acknowledges that {platformName}reserves the right to change these general
          practices and limits at any time, in its sole discretion, with or
          without notice to such Creator.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          EACH CREATOR ACKNOWLEDGES THAT CONTENT MADE PUBLIC ON THE PLATFORM CAN BE PLAYED, SHARED BY LINK AND EMBEDDED BY OTHER USERS, AND THAT SIKI CANNOT CONTROL WHAT A THIRD PARTY DOES WITH CONTENT ONCE IT HAS BEEN COPIED OUTSIDE THE PLATFORM. IF YOU ARE NOT COMFORTABLE WITH THAT, DO NOT MAKE YOUR CONTENT PUBLIC. SIKI HAS NO OBLIGATION TO TAKE ACTION ON YOUR BEHALF AGAINST A THIRD PARTY, BUT WILL PROCESS VALID DMCA NOTICES AS DESCRIBED IN OUR DMCA POLICY.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          <b className="fs-16">Creator DMCA Notice</b> Further, {platformName}does not
          endorse, support or guarantee the completeness, accuracy or
          reliability of any Content or communications posted via the Platform
          or opinions expressed therein. Use of, or reliance on, any Content
          published or otherwise made available on or through the Platform is at
          your own risk. For the avoidance of doubt, {platformName}will not be liable for
          any unauthorized use of Content by any User. You acknowledge and agree
          that your submission of Content to the Platform does not create any
          new, or alter any existing, relationship between you and Siki.
        </Typography>
      </div>
      {/* 6 */}
      <div className="my-10">
        <Typography className="fs-16">6. Purchases, Subscriptions, SIKI, Tips And Payouts</Typography>
        <Typography className="fs-14 text-justify my-10">
          <b>SIKI.</b> SIKI is the credit used inside the Platform to tip Creators, pay for song requests, subscribe to Creators and buy other Platform features. SIKI is a limited, non-transferable (except through Platform features such as sending SIKI to another User), revocable license to use Platform features. SIKI has no cash value outside the Platform, is not a deposit, investment or security, and cannot be exchanged for money except through the cash-out feature described below. The USD value {platformName} assigns to SIKI inside the Platform is set by {platformName} and may change.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          <b>Buying SIKI.</b> In the mobile App, SIKI packs are sold through the Apple App Store or Google Play as in-app purchases and are billed by Apple or Google under their terms; on the Site, purchases are processed by third-party payment processors (such as Stripe or PayPal). All SIKI purchases are final and non-refundable except where required by law or by the store's own refund policy. Refund requests for in-app purchases must be made to Apple or Google.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          <b>Subscriptions.</b> Premium plans and Creator subscriptions renew automatically at the stated price and interval until cancelled. Subscriptions bought in the App are managed and cancelled through your App Store or Google Play account settings; subscriptions paid in SIKI are managed in the Platform and are charged from your SIKI balance on each renewal. Cancelling stops future renewals but does not refund the current period. A gifted subscription runs for the gifted period and does not renew. {platformName} may change subscription prices with notice; continued use after the change takes effect is acceptance of the new price.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          <b>Tips and song requests.</b> Tips and paid song requests are voluntary payments from one User to another and are final once sent. {platformName} retains a platform fee on tips and paid song requests as disclosed in the Platform at the time of payment. A paid song request that the Creator does not fulfil is refunded to the requester in SIKI according to the rules shown in the Platform.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          <b>Royalties.</b> Creators earn royalties in SIKI when Content they own or have rights in is streamed on the Platform, at the per-stream rates published in the Platform, split among the rights holders the Creator declared when uploading. Royalties accrue as pending and are credited to a Creator's balance once the pending amount reaches the payout threshold shown in the Platform. {platformName} may withhold, adjust or reverse royalties, tips or other credits that result from fraud, artificial streams, chargebacks, rights disputes or breach of these Terms of Use.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          <b>Cashing out.</b> Creators may convert earned SIKI to money through the cash-out feature, subject to identity and payment-account verification, a minimum amount, the processing fee and holding period that apply to the User's plan (each shown in the Platform before a cash-out is requested), and applicable law. {platformName} may refuse or delay a cash-out where it reasonably suspects fraud or a breach of these Terms of Use. Purchased SIKI cannot be cashed out; only SIKI earned on the Platform can.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          <b>Taxes.</b> You are responsible for any taxes on amounts you earn through the Platform. {platformName} may collect tax information from you and report or withhold where the law requires.
        </Typography>
      </div>
      {/* 7 */}
      <div className="my-10">
        <Typography className="fs-16">7. [Reserved]</Typography>
      </div>
      {/* 8 */}
      <div className="my-10">
        <Typography className="fs-16">
          8. Public Information; Interaction With Other Users
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          <b className="fs-16">Purpose</b> {platformName}desires to create a Platform You
          acknowledge and agree that certain information that your provide in
          connection with the registration of your Account and other Account
          data (such as your Account profile name and/or picture, city and
          state, social media handles, certain Content uploaded by you or other
          Users to the Platform that you like/follow, how many Users on the
          Platform are following your Account, how many Users on the Platform
          have liked/followed certain Content that you have uploaded to the
          Platform and selected to be made publicly available, and any and all
          comments and messages you post publicly on the Platform) will automatically become publicly viewable by all
          Users of the Platform and that you will not have the option of making
          such information and/or data private. In addition, you acknowledge and
          agree that when you make Content that you upload to the Platform
          publicly available by all other Users of the Platform, that other
          Users of the Platform will be able to listen, like, follow, repost,
          share (applicable Content hyperlink), and/or interact with such
          Content.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          Content shall not contain protected health information. You are
          strictly prohibited from submitting Content that is considered
          protected health information under the Health Insurance Portability
          and Accountability Act of 1996 (HIPAA) or the Health Information
          Technology for Economic and Clinical Health Act of 2009 (HITECH). You
          are also strictly prohibited from submitting through the Platform in
          any manner or otherwise providing {platformName}with any “sensitive
          information,” (which includes, for example, personal information
          specifying medical or health conditions, racial or ethnic origin, or
          trade union membership). None of the foregoing shall obligate {platformName}to
          actively screen the information that you provide.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          The Platform also enables Users to communicate and interact with other
          Users and publicly available Content, including, without limitation,
          by enabling Users to listen, like, share, or re-post other Users’
          Content, and {platformName} may in the future implement functionality to enable
          Users to comment on other Users’ Content, and to direct message other
          Users. The Platform may in the future enable additional User
          interaction features such as public forums/message boards, User
          Content rating systems, and other interactive community-based
          functionalities. You will be publicly identified by your Account
          username or login identifier when communicating and otherwise
          interacting with other Users/ Content on the Platform. You are solely
          responsible for all of your interactions with the Platform and other
          Users/ Content on or through the Platform. In your interactions with
          other Users/Content, you agree to conduct yourself professionally,
          civilly and respectfully at all times and in no event will you harass,
          solicit, stalk, maliciously target, or otherwise make hurtful,
          defamatory, or derogatory comments towards, or engage in malicious
          conduct against, any other User/Content. You acknowledge and agree
          that in using the Platform, {platformName}will not be responsible for the
          actions of any Users with respect to any other User or Content, and
          that {platformName}does not actively monitor or police the specific
          interactions between Users of the Platform and other Users or Content
          (and has no obligation to do so). You hereby release, disclaim and
          hold {platformName}harmless from and against any and all liability resulting
          from a User’s interaction with, or conduct towards, any other User or
          Content (whether online or offline). Notwithstanding the foregoing,
          {platformName}reserves the right to determine, in its sole discretion, what
          constitutes harassment, mischief, or unacceptable conduct with or
          towards other Users or Content, and where that has occurred, and may act on it as described in Section 9 and Section 13.
        </Typography>
      </div>
      {/* 9 */}
      <div className="my-10">
        <Typography className="fs-16">9. Live Streams, Chat And Community Conduct</Typography>
        <Typography className="fs-14 text-justify my-10">
          The Platform lets Users broadcast live audio and video, chat in studios and direct messages, request songs and send tips in real time. Live streams and chat are public to everyone who can access the studio unless the studio is set to subscribers only. You are responsible for everything you broadcast, say or share, including anything shown by your camera or heard by your microphone, and you must have the rights to any music you play during a stream.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          You agree not to use live streams, chat or messages to harass, threaten or abuse anyone; to share sexual content involving minors or non-consensual sexual content; to share other people's private information; to impersonate any person or organisation; to send spam or scams; to infringe anyone's rights; or to break any law. {platformName} may end a stream, remove Content, mute or remove a User from a studio, or suspend or terminate an Account for conduct that breaks these rules, with or without notice.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          A Creator may appoint other Users as moderators of their studio. Moderators can run the studio's music queue and remove Users from the Creator's streams on the Creator's behalf; the Creator remains responsible for their studio. You can report a stream, message or User to {platformName} through the Platform or at contact@siki.io, and block Users you do not want to hear from.
        </Typography>
      </div>
      {/* 10 */}
      <div className="my-10">
        <Typography className="fs-16">
          10. Notifications/Contact; Third Party Content And Communications
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          By providing {platformName}with your email address and using the Platform, you
          hereby affirmatively consent to the use of your email address for
          notifications from {platformName}regarding important Platform announcements and
          other administrative communications related to your use of the
          Platform, various services and functionalities offered thereon, as
          well as certain marketing and other advertising communications from
          {platformName}and from our third-party advertising partners, as more fully set
          forth in our Privacy Policy. You will be able to opt out of receipt of
          certain notifications by following the instructions described in our
          Privacy Policy; however, if you do not wish to receive certain service
          and other administrative notifications related to the Platform, your
          only way to opt out of such messages is to stop using and delete the
          Platform.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          {platformName}disclaims all liability for any communications directed to you
          from any third-party directly or indirectly in connection with the
          Platform (“Third-Party Communications”) that you may receive, and any
          actions you may take or refrain from taking as a result of any
          Third-Party Communications. You are solely responsible for assessing
          and verifying the identity and trustworthiness of the source and
          content of any Third-Party Communications. {platformName}assumes no
          responsibility for verifying, and makes no representations or
          warranties regarding, the identity or trustworthiness of the source or
          content of any Third-Party Communications.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          The Platform includes third-party content or links (such
          as hyperlinks) to third-party websites, products or services
          (including external websites that are framed by the Platform as well
          as any advertisements displayed in connection therewith) that are not
          owned or controlled by {platformName}(collectively, “Third-Party Content”).
          They are provided as an information service, for reference and
          convenience only. {platformName}does not control any such Third-Party Content
          and is not responsible for their (i) availability or accuracy, or (ii)
          content, advertising, or products or services. {platformName}does not make any
          representations or warranties with respect to any Third Party Content
          and all use thereof is provided on an “as is” and “as available” basis
          and your use thereof is at your own risk. Inclusion of any Third-Party
          Content on the Platform does not constitute or indicate {platformName}'s
          endorsement thereof and {platformName}shall not be liable or responsible for
          any Third-Party Content transmitted through the Platform. You shall be
          subject to any additional terms and conditions of use, guidelines or
          rules applicable to any Third-Party Content that you access through
          the Platform (“Third-Party Terms”). All such Third-Party Terms are
          hereby incorporated by reference into these Terms of Use. You
          acknowledge and agree that {platformName}will not and cannot censor or edit any
          Third-Party Content and that you shall assume the sole responsibility
          for and risk associated with your use of Third-Party Content,
          including compliance with the terms and conditions of use, privacy
          policies, or practices associated therewith. Accordingly, Siki
          encourages you to be aware when you leave the Platform and to read the
          terms and conditions of use and privacy policies associated with any
          Third-Party Content.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          By using the Platform, you expressly relieve and hold {platformName}harmless
          from any and all liability arising from your use of any Third-Party
          Communications and Third-Party Content, including any loss or damage
          incurred as a result of any dealings between you and any third
          parties, or as the result of the presence of such Third-Party Content
          on the Platform or the failure of such Third-Party Content to function
          as intended. It is your responsibility to evaluate the content and
          usefulness of the information obtained from Third-Party Content.
        </Typography>
      </div>
      {/* 11 */}
      <div className="my-10">
        <Typography className="fs-16">
          11. Limitations On Platform Use
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          The Platform and any Content belonging to another User may not be
          used, modified, reproduced, duplicated, copied, published,
          distributed, downloaded (unless permitted by a Creator for such
          Creator’s Content), sold, resold, transformed, redesigned,
          reconfigured, retransmitted, or otherwise exploited by you for any
          purpose except as facilitated by the tools, products, services,
          functionalities and/or features made available to Users of the
          Platform, subject to these Terms of Use, or without the express prior
          written consent of Siki, the applicable User, and/or the applicable
          third-party owner thereof, in each instance.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          Without limiting the foregoing, while using the Platform, you may not
          conduct any of the following activities:
        </Typography>
        <ul>
          <li className="fs-14 text-white my-10">
            Defame, abuse, harass, stalk, threaten, bully, or otherwise violate
            the legal rights (such as, but not limited to, rights of privacy and
            publicity) of {platformName}or other Users, or use information learned from
            the Platform to otherwise defame, abuse, harass, stalk, threaten,
            bully, intimidate or mislead, or otherwise violate the legal rights
            of {platformName}or any other User outside of the Platform.
          </li>
          <li className="fs-14 text-white my-10">
            Upload Content to the Platform, or otherwise interact with other
            Users to communicate or distribute information, that is defamatory,
            profane, infringing, obscene, pornographic, unlawful (e.g., drug use
            or other criminal activity), offensive and/or harmful, including,
            but not limited to, content that advocates, endorses, condones or
            promotes racism, bigotry, hatred or physical harm of any kind
            against any individual or group of individuals.
          </li>
          <li className="fs-14 text-white my-10">
            {" "}
            Upload Content to the Platform for which you are not the owner, or
            for which you have not obtained all rights, clearances, licenses and
            other consents required to do so and to grant {platformName}the Content
            License in and to such Content set forth herein.
          </li>
          <li className="fs-14 text-white my-10">
            {" "}
            Solicit or induce, or attempt to solicit or induce, other Users on
            the Platform to take any actions that could be harmful to such Users
            or any other person or property, or that otherwise would violate any
            applicable laws.
          </li>
          <li className="fs-14 text-white my-10">
            {" "}
            Use the Platform for any purpose in violation of applicable local,
            state, national, or international law.
          </li>
          <li className="fs-14 text-white my-10">
            {" "}
            Use or otherwise export or re-export the Platform or any portion
            thereof, or Content in violation of the export control laws and
            regulations of the United States of America.
          </li>
          <li className="fs-14 text-white my-10">
            {" "}
            Upload Content or other material or software that violates the
            intellectual property rights (or rights of privacy or publicity) of
            any third-party or for which you have not obtained the necessary
            rights or permissions to use accordingly.
          </li>
          <li className="fs-14 text-white my-10">
            {" "}
            Upload Content or other material or software that features any
            person that has not given you express permission to include such
            person in such Content and who has not granted you all rights
            necessary or required for you to grant {platformName}the Content License in
            and to such Content, including, without limitation, such person’s
            name, image, voice, likeness, biographical material, and any other
            right of publicity/privacy held by such person in connection with
            such Content.
          </li>
          <li className="fs-14 text-white my-10">
            {" "}
            ◦ Upload Content or other material or software files that contain
            viruses, Trojan horses, corrupted files, malware, spyware, bugs, or
            any other similar programs that may damage or infiltrate the
            operation of the Platform or any other User’s computer or mobile
            device.
          </li>
          <li className="fs-14 text-white my-10">
            Conduct or forward surveys, contests, pyramid schemes, or chain
            letters.{" "}
          </li>
          <li className="fs-14 text-white my-10">
            {" "}
            Advertise or offer to sell any goods or services (other than as
            expressly permitted pursuant to the functionalities and service
            offerings via the Platform) for any commercial purpose through the
            Platform, or otherwise post commercial advertisements, affiliate
            links, and other forms of solicitation, without {platformName}'s prior written
            consent in each instance.
          </li>
          <li className="fs-14 text-white my-10">
            {" "}
            ◦ Impersonate another person or User or knowingly allow any other
            person or entity to use your identification or account to post or
            view comments on, or otherwise utilize, the Platform.
          </li>
          <li className="fs-14 text-white my-10">
            Restrict or inhibit any other User from using and enjoying the
            Platform.{" "}
          </li>
          <li className="fs-14 text-white my-10">
            Imply or state that any statements you make are endorsed by {platformName}or
            any other User, without the prior written consent of {platformName}or such
            User.{" "}
          </li>
          <li className="fs-14 text-white my-10">
            Use a robot, spider, manual and/or automatic processes, or devices
            to data-mine, data-crawl, scrape or index the Platform in any manner
            (excluding SEO-related scraping (e.g., Google indexing)).{" "}
          </li>
          <li className="fs-14 text-white my-10">
            Hack or interfere with the Platform, its servers or any connected
            networks.{" "}
          </li>
          <li className="fs-14 text-white my-10">
            Adapt, alter, license, sublicense or translate the Platform for your
            own personal or commercial use, except as otherwise expressly
            permitted in these Terms of Use.{" "}
          </li>
          <li className="fs-14 text-white my-10">
            Remove or alter, visually or otherwise, any copyrights, trademarks
            or proprietary marks and rights owned by {platformName}or any other User.{" "}
          </li>
          <li className="fs-14 text-white my-10">
            {" "}
            ◦ Upload Content that provides materials or access to materials that
            exploit people under the age of eighteen (18) in an abusive, violent
            or sexual manner.
          </li>
          <li className="fs-14 text-white my-10">
            Use the Platform to collect Registration Data by electronic or other
            means.{" "}
          </li>
          <li className="fs-14 text-white my-10">
            Use the Platform in a manner which is false or misleading (directly
            or by omission or failure to update information) or for the purpose
            of accessing or otherwise obtaining {platformName}'s trade secret information
            for public disclosure or other purposes.{" "}
          </li>
          <li className="fs-14 text-white my-10">
            {" "}
            Direct message any User who has asked you not to do so.
          </li>
          <li className="fs-14 text-white my-10">
            Use, transfer, distribute or dispose of Platform IP or other Users’
            Content in any manner except as expressly authorized in these Terms
            of Use.{" "}
          </li>
          <li className="fs-14 text-white my-10">
            Cause or induce any third-party to engage in the restricted
            activities above.{" "}
          </li>
        </ul>
        <Typography className="fs-14 text-justify my-10">
          {platformName}will take appropriate investigative and legal action for any
          illegal or unauthorized use of the Platform. You acknowledge that
          violation of any of the above restrictions may subject you to
          third-party claims and none of the rights granted to you in these
          Terms of Use may be raised as a defense against any third-party claims
          arising from any such violation.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          If you encounter any Content uploaded by other Users that violates, or
          learn of any User who has violated, these Terms of Use and any of the
          Platform usage restrictions set forth above, please email {platformName} at
          contact@siki.io or inform {platformName} through the applicable reporting
          functionality offered via the Platform. {platformName} may, but is not obligated
          to, take any of the actions set forth in Section 13 below against
          Users who violate any of the above restrictions.
        </Typography>
      </div>
      {/* 12 */}
      <div className="my-10">
        <Typography className="fs-16">
          12. Representations And Warranties
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          The Platform is available only to persons (i) who are eighteen (18)
          years or older (or any greater age required to be deemed to have
          reached the age of majority under the applicable law of the state or
          jurisdiction of such person’s primary residence) or (ii) thirteen (13)
          to seventeen (17) years of age (or any greater age that would still be
          under the age required to be deemed to have reached the age of
          majority under the applicable law of the state or jurisdiction of such
          person’s primary residence) who access and use the Platform with
          parental/legal guardian permission. BY ACCESSING AND USING THE
          PLATFORM, INCLUDING, BUT NOT LIMITED TO, THE CREATION OF AN ACCOUNT,
          YOU REPRESENT AND WARRANT THAT YOU ARE (I) AT LEAST EIGHTEEN (18)
          YEARS OLD (OR ANY GREATER AGE REQUIRED TO BE DEEMED TO HAVE REACHED
          THE AGE OF MAJORITY UNDER THE APPLICABLE LAW OF THE STATE OR
          JURISDICTION OF YOUR PRIMARY RESIDENCE) AND ARE FULLY ABLE AND
          COMPETENT TO ENTER INTO THESE TERMS OF USE, OR (II) AT LEAST THIRTEEN
          (13) YEARS OLD AND HAVE PERMISSION FROM YOUR PARENT OR LEGAL GUARDIAN
          PRIOR TO ACCESSING AND USING THE PLATFORM AND, FOR THE AVOIDANCE OF
          DOUBT, PRIOR TO INITIATING ANY TRANSACTION IN CONNECTION WITH YOUR
          ACCESS AND USE THEREOF, AND YOUR PARENT OR GUARDIAN AGREES TO THESE
          TERMS OF USE.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          You represent and warrant that that you have the right, authority and
          capacity to enter into, and to be bound by, these Terms of Use and to
          abide by the terms and conditions of these Terms of Use, and that you
          will so abide.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          You represent and warrant that: (i) (1) all Registration Data and (2)
          other information that you submit onto the Platform, is true,
          accurate, current and complete; (ii) you are the sole owner of all
          right, title and interest in, or have obtained all necessary rights
          and licenses from the applicable third-party owner of, any Content or
          other information you submit or upload onto the Platform to grant Siki
          the rights set forth herein, free and clear any of further payment or
          attribution requirements; and (iii) that such Content and other
          information, when used for the purposes in which it is submitted onto
          the Platform, does not infringe upon the rights of any third-party,
          including, without limitation, contract rights, intellectual property
          rights, propriety rights and rights of publicity/privacy. You
          acknowledge and agree that you shall be solely responsible for all
          Registration Data, Content and other information that you post,
          upload, link to, publish, exchange, or display onto the Platform and
          that {platformName}reserves the right to reject, refuse to post, edit, modify,
          remove all or a portion of any such Registration Data, Content or
          other information from the Platform that {platformName}determines, in its sole
          discretion, does not comply with these Terms of Use, or for any other
          reason, without notice or liability to you. You represent and warrant
          that any Content, Registration Data, and other information that you
          upload to the Platform: (i) will not be fraudulent; (ii) will not
          violate any law, statute, ordinance, or regulation (including without
          limitation those governing export control, consumer protection, unfair
          competition, anti-discrimination or false advertising); (iii) will not
          be defamatory, libelous, unlawfully threatening, or unlawfully
          harassing; (iv) will not be obscene or contain child pornography or be
          harmful to minors; (v) will not contain any viruses, Trojan Horses,
          worms, time bombs, cancelbots or other computer programming routines
          that are intended to damage, detrimentally interfere with,
          surreptitiously intercept or expropriate any system, data or personal
          information; (vi) will not create liability for {platformName}or cause {platformName}to
          lose (in whole or in part) the services of its Internet service
          providers (ISPs) or other partners or suppliers; and (vii) will not
          feature any person that has not given you express permission to
          include such person in such Content and who has not granted you all
          rights necessary or required for you to grant {platformName}the Content License
          in and to such Content, including, without limitation, such person’s
          name, image, voice, likeness, biographical material, and any other
          right of publicity/privacy held by such person in connection with such
          Content; (viii) will not feature any person under the age of eighteen
          (18) (or any greater age required to be deemed to have reached the age
          of majority under the applicable law of the state or jurisdiction of
          such person’s primary residence) without first obtaining express
          written permission from such person’s parent or legal guardian, and
          which written permission shall grant you all rights necessary or
          required for you to grant {platformName}the Content License in and to such
          Content, including, without limitation, such person’s name, image,
          voice, likeness, biographical material, and any other right of
          publicity/privacy held by such person in connection with such Content.
        </Typography>
      </div>
      {/* 13 */}
      <div className="my-10">
        <Typography className="fs-16">
          13. Unlawful Activity; Suspension Or Termination Of Platform Access
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          We reserve the right to investigate complaints or reported violations
          of the Terms of Use and to take any action {platformName}deems appropriate,
          including, but not limited to, reporting any suspected unlawful
          activity to law enforcement officials, regulators, or other third
          parties and disclosing any information necessary or appropriate to
          such persons or entities relating to Users’ Account, username, e-mail
          addresses, usage history, uploaded Content, IP addresses, and traffic
          information.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          We further reserve the right, in our sole discretion and without
          notice or liability to you, to disable your Account, suspend or
          terminate your use of, or access to, the Platform (either in whole or
          in part), or remove, block, hide or otherwise delete any Content that
          you upload to the Platform, at any time for any reason with any
          conditions, including, but not limited to, if {platformName}believe that you
          have violated or acted inconsistently with these Terms of Use or any
          applicable law or that you have engaged in conduct that {platformName}determine
          to be inappropriate or unacceptable in our sole discretion, including,
          without limitation, any violation of the restrictions set forth in
          Section 12 hereof. We may also disable your Account, suspend or
          terminate your access to the Platform, or remove, block, hide or
          otherwise delete any Content you upload to the Platform, if you file
          any claim against {platformName}or file any claim that involves the Platform.
          If {platformName}terminate, limit, or suspend your right to use the Platform,
          you are prohibited, without {platformName}'s prior written consent, from
          registering and creating a new Account under your name, a fake or
          borrowed name, or the name of any third-party, even if you may be
          acting on behalf of the third-party. In the event your right to use
          the Platform terminated, limited, or suspended, these Terms of Use
          will remain in effect and enforceable against you.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          We also reserve the right, in our sole discretion, to seek and obtain
          any other remedies available to {platformName}pursuant to any applicable laws
          and regulations or at equity as a result of your breach of these Terms
          of Use or any other act or omission by you that gives rise to a claim
          by Siki, and our decision (due to technical or other reasons at our
          sole discretion) to disable (or not disable) your Account, suspend or
          terminate (or not suspend or terminate) your use of, or access to, the
          Platform, or our decision to remove, block, hide, or delete (or not to) any of your Content,
          shall be without prejudice to, and shall not be deemed a waiver of,
          the foregoing.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          You may terminate these Terms of Use at any time by deleting your
          Account and ceasing all use of the Platform. Please note that, ceasing
          to use your Account from your computer or deleting the App (if and
          when launched) from your mobile device will not delete your Account,
          and certain Content that you have previously uploaded will remain on
          the Platform. If you wish to delete your Account, please login to your
          Account on the Platform, and once inside your Account profile, select
          “Delete Account”.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          Notwithstanding the foregoing, all sections of these Terms of Use
          which by their nature should survive the expiration or termination
          shall continue in full force and effect subsequent to and
          notwithstanding the expiration or termination of these Terms of Use.
        </Typography>
        <Typography className="fs-14 text-justify my-10"></Typography>
      </div>
      {/* 14 */}
      <div className="my-10">
        <Typography className="fs-16">
          14. Claims Of Alleged Intellectual Property Infringement{" "}
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          {platformName} respects the intellectual property rights of others and expects
          its users to do the same. In accordance with the Digital Millennium Copyright
          Act of 1998 ("DMCA"), {platformName} has adopted a policy of responding expeditiously
          to claims of copyright infringement. {platformName}'s liability is limited as a
          transitory digital network communication service provider under the Online
          Copyright Infringement Liability Limitation Act (i.e., Title II of the
          Digital Millennium Copyright Act, 17 U.S.C. §512, as amended from time to time).
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          If you believe that your copyrighted work has been copied in a way that
          constitutes copyright infringement and is accessible on the Platform, please
          review our complete DMCA Policy at{" "}
          <a href="/DMCAPolicy">
            https://{platformDomain}/DMCAPolicy
          </a>{" "}
          which includes detailed instructions for filing a DMCA notice, counter-notice
          procedures, and our repeat infringer policy. Our Designated Copyright Agent
          contact information is available on that page.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          {platformName} will respond to proper DMCA notices by removing or disabling access
          to allegedly infringing material and will terminate the accounts of repeat
          infringers in accordance with our DMCA Policy.
        </Typography>
      </div>
      {/* 15 */}
      <div className="my-10">
        <Typography className="fs-16">15. Disclaimer Of Warranties</Typography>
        <Typography className="fs-14 text-justify my-10">
          TO THE EXTENT APPLICABLE, YOU HEREBY WAIVE THE PROTECTIONS OF
          CALIFORNIA CIVIL CODE § 1542 (AND ANY ANALOGOUS LAW IN ANY OTHER
          APPLICABLE JURISDICTION) WHICH SAYS: “A GENERAL RELEASE DOES NOT
          EXTEND TO CLAIMS WHICH THE CREDITOR OR RELEASING PARTY DOES NOT KNOW
          OR SUSPECT TO EXIST IN HIS OR HER FAVOR AT THE TIME OF EXECUTING THE
          RELEASE, WHICH IF KNOWN BY HIM OR HER MUST HAVE MATERIALLY AFFECTED
          HIS OR HER SETTLEMENT WITH THE DEBTOR.” YOUR USE OF THE PLATFORM IS
          ENTIRELY AT YOUR OWN RISK. THE PLATFORM IS PROVIDED ON AN “AS IS”
          BASIS WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED,
          INCLUDING, BUT NOT LIMITED TO, WARRANTIES OF MERCHANTABILITY, FITNESS
          FOR A PARTICULAR PURPOSE AND NON-INFRINGEMENT. COMPANY MAKES NO
          WARRANTIES OR REPRESENTATIONS ABOUT THE ACCURACY, CURRENTESS,
          COMPLETENESS OR RELIABILITY OF ANY PLATFORM CONTENT OR USER CONTENT
          PROVIDED THROUGH THE PLATFORM OR THIRD-PARTY CONTENT LINKED TO THE
          PLATFORM AND ASSUMES NO LIABILITY OR RESPONSIBILITY FOR ANY (I)
          ERRORS, MISTAKES, OR INACCURACIES OF CONTENT, (II) PERSONAL INJURY OR
          PROPERTY DAMAGE, OF ANY NATURE WHATSOEVER, RESULTING FROM YOUR ACCESS
          TO AND USE OF THE PLATFORM, (III) ANY UNAUTHORIZED ACCESS TO OR USE OF
          OUR SECURE SERVERS AND/OR ANY AND ALL PERSONAL INFORMATION STORED
          THEREIN. COMPANY DOES NOT WARRANT, ENDORSE, GUARANTEE OR ASSUME
          RESPONSIBILITY FOR ANY SERVICE ADVERTISED OR OFFERED BY A THIRD-PARTY
          THROUGH THE PLATFORM OR ANY HYPERLINKED WEBSITE OR FEATURED IN ANY
          BANNER OR OTHER ADVERTISING AND COMPANY WILL NOT BE A PARTY TO OR IN
          ANY WAY BE RESPONSIBLE FOR MONITORING ANY TRANSACTION BETWEEN YOU AND
          THIRD-PARTY PROVIDERS OF PRODUCTS OR SERVICES, OTHER THAN AS PROVIDED
          HEREIN. AS WITH THE PURCHASE OF A PRODUCT OR SERVICE THROUGH ANY
          MEDIUM OR IN ANY ENVIRONMENT, YOU SHOULD USE YOUR BEST JUDGMENT AND
          EXERCISE CAUTION WHERE APPROPRIATE. WITHOUT LIMITING THE FOREGOING,
          NEITHER COMPANY NOR ITS AFFILIATES OR LICENSORS WARRANT THAT ACCESS TO
          THE PLATFORM WILL BE UNINTERRUPTED OR THAT THE PLATFORM WILL BE
          ERROR-FREE, OR THAT DEFECTS WILL BE CORRECTED OR THAT IT WILL ALWAYS
          BE ACCESSIBLE; NOR DO THEY MAKE ANY WARRANTY AS TO THE RESULTS THAT
          MAY BE OBTAINED FROM THE USE OF THE PLATFORM, OR AS TO THE TIMELINESS,
          ACCURACY, RELIABILITY, COMPLETENESS OR CONTENT OF ANY CONTENT,
          INFORMATION OR MATERIALS PROVIDED THROUGH OR IN CONNECTION WITH THE
          USE OF THE PLATFORM. NEITHER COMPANY NOR ITS AFFILIATES OR LICENSORS
          IS RESPONSIBLE FOR THE CONDUCT, WHETHER ONLINE OR OFFLINE, OF ANY
          USER. NEITHER COMPANY NOR ITS AFFILIATES OR LICENSORS WARRANT THAT THE
          PLATFORM IS FREE FROM VIRUSES, WORMS, TROJAN HORSES, OR OTHER HARMFUL
          COMPONENTS. COMPANY AND ITS AFFILIATES AND LICENSORS CANNOT AND DO NOT
          GUARANTEE THAT ANY PERSONAL INFORMATION SUPPLIED BY YOU WILL NOT BE
          MISAPPROPRIATED, INTERCEPTED, DELETED, DESTROYED OR USED BY OTHERS.
        </Typography>
      </div>
      {/* 16 */}
      <div className="my-10">
        <Typography className="fs-16">
          16. Limitation Of Liability; Class Action Waiver
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          YOU ACKNOWLEDGE AND AGREE THAT COMPANY IS ONLY WILLING TO PROVIDE THE
          PLATFORM IF YOU AGREE TO CERTAIN LIMITATIONS OF OUR LIABILITY TO YOU
          AND THIRD PARTIES. THEREFORE, YOU AGREE NOT TO HOLD THE COMPANY, ITS
          PARENTS, SUBSIDIARIES, AFFILIATES, LICENSORS, AND PARTNERS IN
          PROMOTIONS, SWEEPSTAKES OR CONTESTS, OR ANY OF SUCH PARTIES’
          RESPECTIVE AGENTS, EMPLOYEES, OFFICERS, DIRECTORS, MANAGERS, MEMBERS,
          VENDORS, THIRD-PARTY LICENSORS, CORPORATE PARTNERS, PARTICIPANTS,
          SUCCESSORS, AND ASSIGNS (COLLECTIVELY, “COMPANY PARTIES”) LIABLE FOR
          ANY DAMAGE, SUITS, CLAIMS, AND/OR CONTROVERSIES (COLLECTIVELY,
          “LIABILITIES”) THAT HAVE ARISEN OR MAY ARISE, WHETHER KNOWN OR
          UNKNOWN, RELATING TO YOUR OR ANY OTHER PARTY’S USE OF OR INABILITY TO
          USE THE PLATFORM, INCLUDING WITHOUT LIMITATION ANY LIABILITIES ARISING
          IN CONNECTION WITH THE CONDUCT, ACT OR OMISSION OF ANY USER (INCLUDING
          WITHOUT LIMITATION STALKING, HARASSMENT THAT IS SEXUAL OR OTHERWISE,
          ACTS OF PHYSICAL VIOLENCE, AND DESTRUCTION OF PERSONAL PROPERTY), ANY
          DISPUTE WITH ANY USER, ANY INSTRUCTION, ADVICE, ACT, OR SERVICE
          PROVIDED BY COMPANY OR ITS AFFILIATES OR LICENSORS AND ANY DESTRUCTION
          OF YOUR INFORMATION. UNDER NO CIRCUMSTANCES WILL ANY COMPANY PARTIES
          BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, CONSEQUENTIAL, SPECIAL
          OR EXEMPLARY DAMAGES ARISING IN CONNECTION WITH YOUR USE OF OR
          INABILITY TO USE THE PLATFORM, EVEN IF ADVISED OF THE POSSIBILITY OF
          THE SAME. SOME STATES DO NOT ALLOW THE EXCLUSION OR LIMITATION OF
          INCIDENTAL OR CONSEQUENTIAL DAMAGES, SO THE ABOVE LIMITATIONS MAY NOT
          APPLY TO YOU. IF, NOTWITHSTANDING THE FOREGOING EXCLUSIONS, IT IS
          DETERMINED THAT ANY COMPANY PARTY IS LIABLE FOR DAMAGES, IN NO EVENT
          WILL THE AGGREGATE LIABILITY, WHETHER ARISING IN CONTRACT, TORT,
          STRICT LIABILITY OR OTHERWISE, EXCEED ONE HUNDRED U.S. DOLLARS
          ($100.00). ANY DISPUTE YOU HAVE WITH ANY THIRD-PARTY ARISING OUT OF
          YOUR USE OF THE PLATFORM, INCLUDING, BY WAY OF EXAMPLE AND NOT
          LIMITATION, ANY CARRIER, COPYRIGHT OWNER OR OTHER USER, IS DIRECTLY
          BETWEEN YOU AND SUCH THIRD-PARTY, AND YOU IRREVOCABLY RELEASE THE
          COMPANY PARTIES FROM ANY AND ALL CLAIMS, DEMANDS AND DAMAGES (ACTUAL
          AND CONSEQUENTIAL) OF EVERY KIND AND NATURE, KNOWN AND UNKNOWN,
          ARISING OUT OF OR IN ANY WAY CONNECTED WITH SUCH DISPUTES. YOU AND
          COMPANY AGREE THAT ANY PROCEEDINGS TO RESOLVE OR LITIGATE ANY DISPUTE
          WILL BE CONDUCTED SOLELY ON AN INDIVIDUAL BASIS, AND THAT NEITHER YOU
          NOR COMPANY WILL SEEK TO HAVE ANY DISPUTE HEARD AS A CLASS ACTION, A
          REPRESENTATIVE ACTION, A COLLECTIVE ACTION, A PRIVATE ATTORNEY-GENERAL
          ACTION, OR IN ANY PROCEEDING IN WHICH YOU OR COMPANY ACTS OR PROPOSES
          TO ACT IN A REPRESENTATIVE CAPACITY. YOU AND COMPANY FURTHER AGREE
          THAT NO PROCEEDING WILL BE JOINED, CONSOLIDATED, OR COMBINED WITH
          ANOTHER PROCEEDING WITHOUT THE PRIOR WRITTEN CONSENT OF YOU, COMPANY,
          AND ALL PARTIES TO ANY SUCH PROCEEDING.
        </Typography>
      </div>
      {/* 17 */}
      <div className="my-10">
        <Typography className="fs-16">17. Indemnification</Typography>
        <Typography className="fs-14 text-justify my-10">
          You hereby agree to indemnify, defend and hold harmless, the Siki
          Parties, from and against any and all losses, liabilities, damages,
          costs or expenses (including reasonable attorneys’ fees and costs)
          arising out of or in connection with any claim, action, or proceeding
          brought by a third-party based on: (i) your use of, or inability to
          use, the Platform; (ii) any breach of any representation, warranty,
          covenant or obligation of yours under these Terms of Use; (iii) any
          Registration Data or Content posted by you onto the Platform; (iv)
          your violation of any applicable law or regulation; or (v) your
          violation of any third-party right, including, but not limited to, any
          intellectual property right. {platformName}shall promptly notify you of any
          such claim, and you shall assume control of the defense of such claim
          upon {platformName}'s request. {platformName}reserves the right, at its own expense, to
          assume the exclusive defense and control of any matter otherwise
          subject to your indemnification. You will not, in any event, settle
          any claim or matter without the written consent of Siki.
        </Typography>
      </div>
      {/* 18 */}
      <div className="my-10">
        <Typography className="fs-16">
          18. Platform Access Requirements; Updates And Maintenance
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          Access to and use of the Platform requires a compatible mobile
          device/web browser and internet connection. It also requires that Siki
          have access to your device identifier and location information.
          Although {platformName}are working to ensure that the Platform is compatible
          across various devices, {platformName}cannot guarantee that the Platform will
          work with all devices.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          It is your responsibility to ensure that your computer or mobile
          device complies with the requirements for accessibility. Your use of
          the Platform may vary in functionality, availability and quality
          depending on the type of the device and the operating system that you
          use and {platformName}accepts no responsibility for any lack of functionality
          that is due to your equipment (including your device, internet
          connection, operating system or settings and software).
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          It is your responsibility to pay for all costs and expenses that you
          may incur while using the Platform (including, but not limited to, all
          telephone call or line charges or Internet data service access
          charges).
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          Your access to the Platform may be interfered with by numerous factors
          outside of {platformName}'s control including, but not limited to,
          telecommunications and/or wireless network service disruptions,
          computer or mobile device viruses and bugs, tampering, unauthorized
          intervention, fraud, technical failures, and server, equipment or
          software defects. {platformName} is not responsible and will have no liability
          for any failures of the Internet or any data or telecommunications
          equipment, system or network used in connection with the Platform. In
          addition, perfect security does not exist on the Internet; {platformName}cannot
          and does not guarantee that any Registration Data or other personally
          identifiable information submitted to the Platform and selected by you
          to remain private (as applicable) will not become public under any
          circumstances. {platformName} may in the future update the Platform for repair
          or maintenance purposes or to change any tools, products, services,
          functionalities, or features thereof (an “Update”). {platformName}shall not be
          liable to any User in any way as a result of any temporary or
          permanent suspension of the Platform or any tools, products, services,
          functionalities, or features thereof arising from or in connection
          with an Update. Furthermore, {platformName} is under no obligation to undergo an
          Update of the Platform to the extent any Platform Elements, Content
          and/or other tool, product, service, functionality, or feature thereof
          is out of date. The terms of the License granted to you hereunder
          shall apply in full to any Update. Following an Update, you may not be
          able to use the Platform until you have downloaded the latest version
          and accepted any new terms.
        </Typography>
      </div>
      {/* 19 */}
      <div className="my-10">
        <Typography className="fs-16">19. No Agency</Typography>
        <Typography className="fs-14 text-justify my-10">
          No agency, partnership, joint venture, employee-employer or
          franchiser-franchisee relationship is intended or created between you
          and {platformName}by this Agreement.
        </Typography>
      </div>
      {/* 20 */}
      <div className="my-10">
        <Typography className="fs-16">20. Assignment</Typography>
        <Typography className="fs-14 text-justify my-10">
          {platformName} may freely assign, sub-contract and/or otherwise transfer any or
          all of its rights and/or obligations under these Terms of Use to any
          company, firm or person. You may not transfer your rights or
          obligations under these Terms of Use to anyone else.
        </Typography>
      </div>
      {/* 21 */}
      <div className="my-10">
        <Typography className="fs-16">
          21. Waiver And Severability Of Terms; Entire Agreement
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          Failure by {platformName}to enforce any provision(s) of these Terms of Use will
          not be construed as a waiver of any provision or right. If any
          provision of these Terms of Use is deemed unlawful, void or
          unenforceable by a court of law exercising proper jurisdiction, that
          provision shall be deemed severed from the remaining provisions and
          shall not affect their validity and enforceability. These Terms of Use
          incorporate by reference any notices contained on the Platform and the
          Privacy Policy and constitute the entire agreement with respect to
          access to and use of the Platform and your and other Users’ Content.
        </Typography>
      </div>
      {/* 22 */}
      <div className="my-10">
        <Typography className="fs-16">22. Third Party Disputes</Typography>
        <Typography className="fs-14 text-justify my-10">
          Failure by {platformName}to enforce any provision(s) of these Terms of Use will
          not be construed as a waiver of any provision or right. If any
          provision of these Terms of Use is deemed unlawful, void or
          unenforceable by a court of law exercising proper jurisdiction, that
          provision shall be deemed severed from the remaining provisions and
          shall not affect their validity and enforceability. These Terms of Use
          incorporate by reference any notices contained on the Platform and the
          Privacy Policy and constitute the entire agreement with respect to
          access to and use of the Platform and your and other Users’ Content.
        </Typography>
      </div>
      {/* 23 */}
      <div className="my-10">
        <Typography className="fs-16">
          23. Governing Law And Jurisdiction; Disputes
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          The Terms of Use are governed by and construed in accordance with the
          internal laws of the State of California, without reference to
          principles of conflicts of laws, and any action arising out of or
          relating to these Terms of Use shall be filed exclusively in the state
          or federal courts located in New York County, New York, and you
          consent to the jurisdiction thereof and venue of such courts for the
          purpose of litigating any such action.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          You agree that regardless of any applicable statute or law to the
          contrary, any claim or cause of action arising out of or related to
          your use of the Platform or these Terms of Use must be filed within
          one (1) year after such claim or cause of action arose or be forever
          and fully barred.
        </Typography>
      </div>
      {/* 24 */}
      <div className="my-10">
        <Typography className="fs-16">
          24. Modification Of Services Or Terms And Policies
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          {platformName} may, from time to time, release updates of the Platform, or
          release/introduce new tools, products, services, functionalities,
          and/or features for the Platform, which will be subject to these Terms
          of Use, and any additional terms as may apply to such additional
          versions, tools, products, services, functionalities, or features.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          {platformName}reserves the right to alter these Terms of Use, the Privacy
          Policy https://www.siki.io/PrivacyPolicy, or other Platform policies
          at any time, so please review the policies frequently. Your continued
          use of the Platform will act as your unqualified acceptance of any
          changes to the Terms and Policies, regardless of actual notice.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          {platformName} reserves the right to discontinue the Service or any part of it for any reason, without notice, at any time.
        </Typography>
      </div>
      {/* 25 */}
      <div className="my-10">
        <Typography className="fs-16">25. Feedback</Typography>
        <Typography className="fs-14 text-justify my-10">
          While our own staff is continually working to develop and evaluate our
          own product ideas and features, {platformName}pride ourselves on paying close
          attention to the interests, feedback, comments, and suggestions Siki
          receive from the User community. If you choose to contribute by
          sending {platformName}or our employees any ideas for services, features,
          modifications, enhancements, content, refinements, technologies,
          content offerings, promotions, strategies, or product/feature names,
          or any related documentation, artwork, computer code, diagrams, or
          other materials (collectively, “Feedback”), then regardless of what
          your accompanying communication may say, the following terms will
          apply, so that future misunderstandings can be avoided. Accordingly,
          by sending {platformName}Feedback, you agree that: (i) {platformName}has no obligation
          to review, consider, or implement your Feedback, or to return to you
          all or part of any Feedback for any reason; (ii) Feedback is provided
          on a non-confidential basis, and {platformName} is not under any obligation to
          keep any Feedback you send confidential or to refrain from using or
          disclosing it in any way; and (iii) you irrevocably grant {platformName}a
          perpetual and unlimited permission to reproduce, distribute, create
          derivative works of, modify, publicly perform (including on a
          through-to-the-audience basis), communicate to the public, make
          available, publicly display, and otherwise use and exploit the
          Feedback and derivatives thereof for any purpose and without
          restriction, free of charge and without attribution of any kind,
          including by making, using, selling, offering for sale, importing, and
          promoting commercial products and services that incorporate or embody
          Feedback, whether in whole or in part, and whether as provided or as
          modified.
        </Typography>
      </div>
      {/* 26 */}
      <div className="my-10">
        <Typography className="fs-16">26. Open Source Software</Typography>
        <Typography className="fs-14 text-justify my-10">
          The Platform contains certain open source software. Each item of open
          source software is subject to its own applicable license terms. Some services offered through the Platform (for example, purchases billed by the Apple App Store, Google Play or a payment processor) are also subject to those third parties' terms and conditions. Your use of those services is subject to
          those third party terms and conditions, which are incorporated into
          these Terms of Use by this reference.
        </Typography>
      </div>
      {/* 27 */}
      <div className="my-10">
        <Typography className="fs-16">27. Privacy</Typography>
        <Typography className="fs-14 text-justify my-10">
          Your privacy is very important to us. To understand our practices,
          please review our Privacy Policy at{" "}
          <a href="/PrivacyPolicy">
            https://{platformDomain}/PrivacyPolicy
          </a>
          , which is incorporated by reference into these Terms of Use and also
          governs your use of the Platform. Likewise, you represent and warrant
          that you will respect the privacy, property, and data protection
          rights of Users.
        </Typography>
      </div>
      {/* 28 */}
      <div className="my-10">
        <Typography className="fs-16">28. Contact</Typography>
        <Typography className="fs-14 text-justify my-10">
          General questions or comments about the Platform or these Terms of Use
          should be sent either by mail to {companyName} at
          {" "}{companyAddress}, or email to contact@siki.io.
        </Typography>
      </div>
      </Box>
    </Box>
  );
}
